import { getRefereeCookie } from '@interlayer/js/app/utils/referrer.util';
import { PLAYER_TAG_TYPES } from '@interlayer/js/hooks/user/store/buzz/constants';
import { IPlayerTag } from '@interlayer/js/hooks/user/store/buzz/types';

export const getRefereeCookieForReg = (): IPlayerTag[] | undefined => {
    const rafCookie = (getRefereeCookie('referrer') as {
        referrer?: string;
    })?.referrer;

    if (rafCookie) {
        return [
            {
                name: 'RAF/referred_by',
                type: PLAYER_TAG_TYPES.TEXT,
                expirationDate: '',
                value: rafCookie
            },
            {
                name: 'RAF/is_referred',
                type: PLAYER_TAG_TYPES.TEXT,
                expirationDate: '',
                value: 'yes'
            }
        ];
    }
};
